import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Button, Icon } from '@drifthq/tide-core'
import DynamicCalendarSvg from './dynamicCalendarSvg'

import GoogleOauth from './GoogleOauth'
import MicrosoftOauth from './MicrosoftOauth'
import './style.css'

export const CONNECT_ERRORS = Object.freeze({
  GMAIL: 'GMAIL',
  MICROSOFT: 'MICROSOFT'
})


export const MeetingsStepWithPrime = ({ color, primed, setPrimed, triedSkipping, skipFirst, connectError, setConnectError, onSkipClick, isCalendarSeat }) => {
  const HEADER_COPY = triedSkipping
    ? 'You need to connect your calendar to Book Meetings!'
    : 'Connect your Calendar to Book Meetings Faster'

  const SUBHEADER_COPY_COMPONENT = triedSkipping
    ? <p className="subtitle">You’ll have <b>full control</b> over when and where people can book time with you, and we’ll make sure your <b>never double booked</b>.</p>
    : <p className="subtitle">Give people a direct line to your calendar so you can spend more of your time selling, and less of it scheduling</p>

  const FOOTER_COPY_COMPONENT = triedSkipping
    ? <div className="calendar-footer">Spend more of your time selling, and less of it scheduling</div>
    : <div className="calendar-footer">With a connected calendar, <b>your Drift Assistant</b> will prepare you for all of your meetings, and keep an eye on your calendar so you don’t get double booked.</div>

  return (
    <Fragment>
      <h1>{HEADER_COPY}</h1>
      
      {SUBHEADER_COPY_COMPONENT}

      {primed ? (
        <Fragment>
          <div className="setup-meetings-calendars-container" >
            <GoogleOauth setConnectError={setConnectError} isCalendarSeat={false} />
            <MicrosoftOauth setConnectError={setConnectError} isCalendarSeat={false} />
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="dynamic-calendar-svg-wrapper" >
            <DynamicCalendarSvg color={color} />
          </div>
          <Button className="choose-calendar-button-prime" onClick={() => setPrimed(true)}>Choose calendar</Button>
        </Fragment>
      )}

      {FOOTER_COPY_COMPONENT}
      
      {primed && <a
        className="skip-for-now"
        onClick={triedSkipping ? onSkipClick : skipFirst}
      >
        {`Don't connect my calendar` }
      </a> }
    </Fragment>
  )
}

export const AEMeetingsStepWithPrime = ({ color, primed, setPrimed, triedSkipping, skipFirst, connectError, setConnectError, onSkipClick }) => {
  const HEADER_COPY = primed
    ? 'What calendar do you use?'
    : 'Connect your calendar so your teammates can book meetings for you'

  return (
    <Fragment>
      <h1>{HEADER_COPY}</h1>
      {primed ? (
        <Fragment>
          <div className="setup-meetings-calendars-container calendar-connect-padding" >
            <GoogleOauth setConnectError={setConnectError} isCalendarSeat={true} />
            <MicrosoftOauth setConnectError={setConnectError} isCalendarSeat={true} />
          </div>
          <div className="choose-calendar-AE-seat-copy">Don&rsquo;t worry, we&rsquo;ll make sure you&rsquo;re never double booked.</div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="dynamic-calendar-svg-wrapper calendar-svg-padding" >
            <DynamicCalendarSvg color={color} />
          </div>
          <div className="choose-calendar-AE-seat-copy">You&rsquo;ll have full control over when people can book time with you and we&rsquo;ll make sure you&rsquo;re never double booked.</div>
          <Button className="choose-calendar-button-prime" onClick={() => setPrimed(true)}>Choose calendar</Button>
        </Fragment>
      )}
      {!primed && (
        <Link 
          className="calendar-back-arrow"
          to="/setup/calendaring/profile">
          <Icon name="arrow-1-left" className="welcome-back-caret"/>
          Back
        </Link>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/component.js